export const PEXELS_URL = 'https://www.pexels.com'

export const TERMS_AND_CONDITIONS_URL = 'https://www.trackgood.io/terms-of-service'

export const TRACKGOOD_AI_URL = 'https://www.trackgood.ai/'
